import { useEffect, useRef, useState } from 'react';
import { MAX_ARCHIVE_SELECTION } from './archive-store';
import { Icon } from './JournalOverview';
import { ArchivePicker } from './TradeLibrary';

export function useTradeSelection(trades, filterKey) {
  const [enabled, setEnabled] = useState(false), [selected, setSelected] = useState(new Set()), [action, setAction] = useState(null);
  useEffect(() => { setSelected(new Set()); }, [filterKey]);
  useEffect(() => {
    const ids = new Set(trades.map(t => t.id));
    setSelected(previous => [...previous].every(id => ids.has(id)) ? previous : new Set([...previous].filter(id => ids.has(id))));
  }, [trades]);
  const toggle = id => setSelected(previous => {
    const next = new Set(previous);
    if (next.has(id)) next.delete(id); else if (next.size < MAX_ARCHIVE_SELECTION) next.add(id);
    return next;
  });
  return { enabled, selected, action, setAction, toggle, setSelected,
    toggleMode: () => { setEnabled(v => !v); setSelected(new Set()); },
    close: () => setAction(null),
  };
}

export default function TradeSelection({ selection, filtered, archived, folders, onMove }) {
  const checkbox = useRef(null), { selected, setSelected } = selection;
  const available = filtered.slice(0, MAX_ARCHIVE_SELECTION);
  const allSelected = available.length > 0 && available.every(t => selected.has(t.id));
  useEffect(() => { if (checkbox.current) checkbox.current.indeterminate = selected.size > 0 && !allSelected; }, [selected.size, allSelected]);
  return <>
    {selection.enabled && <div className="tl-selection-bar">
      <label className="tl-select-all"><input ref={checkbox} type="checkbox" aria-label={filtered.length > MAX_ARCHIVE_SELECTION ? `Select first ${MAX_ARCHIVE_SELECTION} matching trades` : 'Select all matching trades'} checked={allSelected} disabled={!filtered.length} onChange={() => setSelected(allSelected ? new Set() : new Set(available.map(t => t.id)))}/><span>{selected.size ? `${selected.size} selected` : 'Select trades'}</span></label>
      <div>{selected.size > 0 && <button className="tl-text-button" onClick={() => setSelected(new Set())}>Clear</button>}{archived && <button className="tl-btn" disabled={!selected.size} onClick={() => selection.setAction({ ids: [...selected], restoring: true })}><Icon name="history" size={15}/>Restore</button>}<button className="tl-btn tl-btn-primary" disabled={!selected.size} onClick={() => selection.setAction({ ids: [...selected] })}><Icon name="archive" size={16}/>{archived ? 'Move to folder' : 'Archive selected'}</button></div>
      {filtered.length > MAX_ARCHIVE_SELECTION && <small>Move up to {MAX_ARCHIVE_SELECTION} trades at a time. Your filters apply to this selection.</small>}
    </div>}
    {selection.action && <ArchivePicker {...selection.action} folders={folders} onMove={async (...args) => { const result = await onMove(...args); setSelected(new Set()); return result; }} onClose={selection.close}/>}
  </>;
}
